<template lang="pug">
v-dialog#pemegangModal(
  v-model="openModal",
  width="50%",
  :fullscreen="$vuetify.breakpoint.xsOnly"
)
  v-form
    v-card(:height="modalHeightDynamic")
      v-card-title.headline.grey.lighten-2 Search Departmen
      v-card-text
        v-container
          v-layout(row, wrap)
            v-flex(xs8, sm8)
              br
              v-text-field(
                label="Nama Departmen",
                required,
                v-model="department",
                @keyup.enter="search",
                :rules="rules"
              )
            v-flex(xs4, sm4)
              br
              br
              v-btn(color="blue darken-1", text, bottom, @click="search") Search
            v-flex(xs12, sm12)
              v-data-table(
                :headers="tableData.headers",
                :items="tableData.items",
                :items-per-page="5"
              )
                template(v-slot:item.actions="{ item }")
                  v-checkbox.locationOptions(
                    small,
                    v-model="selected",
                    :value="item.name",
                    style="margin-top: 10px; margin-bottom: -10px"
                  )
      v-card-actions
        v-spacer
        v-btn(color="blue darken-1", text, @click="closingModal") Close
        v-btn(color="blue darken-1", text, @click="saveData") SELECT
</template>

<script>
import { mapState } from "vuex";
import axios from "axios";
export default {
  name: "DepartmentAddUser",
  components: {},
  props:['openModal'],
  mounted() {
    // this.selected = this.departmentData
    // this.tableData.items = this.departmentData.map(data =>{
    //   return {name : data}
    // })

    this.modalHeightDynamic = false;
    axios({
      method: "get",
      url: `${this.API_URL}/form/getIsafeDepartment`,
      headers: { Authorization: `Bearer ${this.tokenIsafe}` },
    })
      .then((response) => {
        this.tableData.items = response.data.data;
        this.dataSearch = response.data.data;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  data() {
    return {
      selected: [],
      department: "",
      modalHeight: "",
      dataSearch :[],
      departmentData:[],
      tableData: {
        headers: [
          { text: "Nama Departmen", value: "name", width: "95%" },
          { text: "Action", value: "actions" },
        ],
        items: [],
      },
      rules: [
        (value) =>
        (value && value.length >= 2) || 'Min 2 characters' || !this.searchBTn.input-value
      ],
      closing: false,
      docPelaporan: null,
      emptyUpload: new File([""], "", {
        type: "",
      }),
    };
  },
  computed: {
    ...mapState([
      "API_URL",
      "tokenIsafe",
      "token",
    ]),
    modalHeightDynamic: {
      get() {
        return this.modalHeight;
      },
      set(val) {
        const delta = this.dynamicHeight(val);
        this.modalHeight = delta;
      },
    },
  },
  methods: {
    dynamicHeight: function (search) {
      const isMobile = this.$vuetify.breakpoint.xsOnly;
      const mobileHeight = this.$vuetify.breakpoint.height;
      if (search) {
        if (this.tableData.items.length < 3) {
          return mobileHeight;
        }
        return "";
      }
      if (isMobile) {
        return `${mobileHeight}`;
      }
      return "";
    },
    search() {
      if (this.department.length >= 2) {
        const keywordToSearch = this.department;
        const keyword = keywordToSearch.toLowerCase();
        const searchResult = this.dataSearch?.filter((data) => data.name.toLowerCase().indexOf(keyword) > -1);
        this.tableData.items = searchResult;
      }
    },
    saveData() {
      this.$emit("selectedDepartment", this.selected);
      this.departmentData = this.selected
      this.tableData.items = this.departmentData.map(data =>{
         return {name : data}
    })
      this.department = '';
      this.$emit("closeModal", false);
    },
    closingModal() {
      this.selected = this.departmentData
      this.department = '';
      // this.tableData.items = this.dataSearch
      this.$emit("closeModal", false);
    },
  },
  watch: {
    // selected(){
    //   this.tableData.items = this.selected.map(data =>{
    //   return {name : data}
    // })
    // }
  },
};
</script>

<style scoped>
.print-bg {
  background: rgb(204, 204, 204);
  padding-top: 10px;
}
.print-bg > div {
  text-align: center;
}
.page {
  background: white;
  display: block;
  margin: 5px auto;
  padding: 0.7cm 1cm 0.8cm;
  position: relative;
}
.page[size="A4"] {
  width: 21cm;
  height: 29.7cm;
}
.page[size="Auto"] {
  width: auto;
  margin: 0 auto;
  display: inline-block;
  text-align: initial;
}
.view-width {
  width: 11.3cm;
}
.print-header {
  border-collapse: collapse;
  text-align: right;
}
.padding-x-3 {
  padding: 0 3px;
}
.padding-xy-5 {
  padding: 2px;
}
.padding-xy-1 {
  padding: 1px;
}
.margin-tl-5 {
  margin: 3px 5px 0 5px;
}
.margin-tl-10 {
  margin: 3px 10px 0 10px;
}
.margin-tl-25 {
  margin: 3px 15px 0 25px;
}
.logo-cell {
  padding: 8px 5px 0px;
  width: 35%;
}
.detail-wrap {
  margin-top: 5px;
}
.border-left-0 {
  border-left: 0;
}
.border-right-0 {
  border-right: 0;
}
.approved {
  text-align: center;
  padding: 5px;
}
.ff0000 {
  color: #ff0000;
}
.align-center {
  text-align: center;
}
.align-left {
  align-items: left;
}
.width-20p {
  width: 20%;
}
.width-25p {
  width: 25%;
}
.height-40px {
  height: 40px;
}
.width-300px {
  width: 250px;
}
.top-align {
  vertical-align: top;
}
.navFixed {
  position: fixed;
  z-index: 9;
}
.padTop60 {
  padding-top: 60px;
}
.blink {
  -webkit-animation: blink 2s steps(5, start) infinite;
  animation: blink 2s steps(5, start) infinite;
  color: #dddddd;
}
@-webkit-keyframes blink {
  to {
    color: #ffffff;
  }
}
@keyframes blink {
  to {
    color: #ffffff;
  }
}
@media print {
}
table {
  border-collapse: collapse;
}
.headerTable {
  border: 1px solid black;
  background-color: #cccccc;
}
.tableInput td {
  border: 1px solid black;
  padding-left: 5px;
}
.verMiddle {
  vertical-align: middle;
}
</style>